<!-- 未使用 -->
<template>
  <div class="kiken">
    <h3>危険手当</h3>
    <div class="multi-date-table" v-for="(item, index) in kiken" :key="index">
      <div class="head"><b>危険{{ (index + 1) }}</b></div>
      <div class="flex">
        <div class="item full-width">
          <b class="required">取得日</b>
          <date-picker v-model="item.shinsei_date" :error="getError(item, 'shinsei_date')"></date-picker>
        </div>
      </div>
      <div class="row-button">
        <i class="fa-solid fa-delete-left" @click="removeTableRow(kiken, index)" v-if="(kiken.length > 1)"></i>
      </div>
    </div>
    <p class="item btn-table-add">
      <button type="button" class="btn primary" @click="addRow">
        <i class="fa-solid fa-plus"></i>追加
      </button>
    </p>
    <div class="item">
      <b>備考</b>
      <input-textarea v-model="form.notes" :error="getError(form, 'notes')"></input-textarea>
    </div>
  </div>
</template>

<script lang="ts">

import { defineComponent } from 'vue'
import { useInit } from "@/composable/shinsei/kiken/init";
import { useForm } from "@/composable/form/form";
import { useTableRow } from "@/composable/common/tablerow";
import { Shinsei, Kiken } from '@/types/Shinsei';

export default defineComponent({
  props: {
    form: {
      type: Object as () => Shinsei,
      default: null
    },
  },
  setup(props) {
    const { kiken } = useInit(props.form);

    const { getError } = useForm();

    const { addRowNoRef, removeTableRow } = useTableRow();

    // 行追加
    const addRow = () => {
      const row: Kiken = {
        shinsei_date: null
      }
      addRowNoRef(kiken, row)
    }

    return {
      kiken,
      getError,
      addRow,
      removeTableRow
    }
  },
  components: {

  }
})

</script>
<style lang="scss" scoped>
@import '@scss/components/shinsei-create.scss';
</style>
